export default __webpack_public_path__ + "static/media/equity-banner-inner-mob.bafd6ea3.jpg";